import "./DashboardAddressSkeleton.css";

export default function DashboardAddressesSkeleton() {
  return (
    <div className="wrapper dashboard-addresses-skeleton">

      {/* Title */}
      <div className="das-title skeleton-box" />

      {/* Address List */}
      <div className="das-address-list">

        <SkeletonAddressCard />
        <SkeletonAddressCard />
        <SkeletonAddressCard />

      </div>

      {/* Add New Address */}
      <div className="das-add-address">

        <div className="das-add-right">

          <div className="das-plus skeleton-box" />

          <div className="das-add-title skeleton-box" />

        </div>

        <div className="das-chevron skeleton-box" />

      </div>

    </div>
  );
}


/* ---------------------------------------
   Address Card Skeleton
--------------------------------------- */

function SkeletonAddressCard() {
  return (
    <div className="das-address-card">

      {/* Header */}
      <div className="das-card-header">

        <div className="das-name skeleton-box" />

        <div className="das-actions">

          <div className="das-action skeleton-box" />
          <div className="das-action skeleton-box" />

        </div>

      </div>


      {/* Address */}
      <div className="das-address-lines">

        <div className="das-address-line long skeleton-box" />

        <div className="das-address-line medium skeleton-box" />

      </div>


      {/* Details */}
      <div className="das-details">

        <div className="das-detail-item">

          <div className="das-detail-label skeleton-box" />
          <div className="das-detail-value skeleton-box" />

        </div>

        <div className="das-detail-item">

          <div className="das-detail-label skeleton-box" />
          <div className="das-detail-value skeleton-box" />

        </div>

        <div className="das-detail-item">

          <div className="das-detail-label skeleton-box" />
          <div className="das-detail-value skeleton-box" />

        </div>

      </div>

    </div>
  );
}